<template>
    <div class="card shadow"
         :class="type === 'dark' ? 'bg-default': ''">
        <div class="card-header border-0"
             :class="type === 'dark' ? 'bg-transparent': ''">
            <div class="row align-items-center">
                <div class="col">
                    <h3 class="mb-0" :class="type === 'dark' ? 'text-white': ''">
                        {{title}}
                    </h3>
                </div> 
            </div>
        </div>

        <div class="table-responsive" v-bind:style="{cursor:pointer}">
            <base-table class="table align-items-center table-flush"
                        :class="type === 'dark' ? 'table-dark': ''"
                        :thead-classes="type === 'dark' ? 'thead-dark': 'thead-light'"
                        tbody-classes="list"
                        :data="data"
                        :period="period">

                <template slot="columns">
                    <th v-bind:style="{cursor:pointer2}">Bancos</th>
                    <th v-bind:style="{cursor:pointer2}" class="text-center">Total Cuentas</th>
                    <th v-bind:style="{cursor:pointer2}" class="text-center">Suma de Deudas</th>
                </template>

                <template slot-scope="{row}">
                    <td>{{row.bank}} </td>
                    <td class="text-center">{{row.accounts}}</td>
                    <td class="text-center">{{formatCurrency(row.amount)}}</td>
                </template>
            </base-table>
        </div>

          <div class="card-footer d-flex justify-content-end"
             :class="type === 'dark' ? 'bg-transparent': ''">
            <div class="col">
                <p class="mb-0" :class="type === 'dark' ? 'text-white': ''">
                    Página {{pagination.currentPage}} de {{Math.ceil(pagination.total/pagination.perPage)}}<br>{{pagination.total}} Bancos
                </p>
            </div>
            <base-pagination
                    size="sm"
                    :total="pagination.total"
                    :per-page="pagination.perPage"
                    :value="pagination.currentPage"
                    v-on:pageSelected="pageSelected"/>
        </div>

    </div>
</template>
<script>
    export default {
        name: 'accounts-per-banks-table',
        props: {
            type: {
                type: String
            },
            title: String,
            data: Array,
            pagination: Object,
            period: {
                start: null,
                end: null
            },
        },
        data() {
            return {
                isAdmin: false,
                showSetPeriod: false,
                tableData: [],
                eventFilter: null,
                deviceFilter: null,
                consultantFilter: null,
                periodFilter: null,
                pointer: 'pointer',
                pointer2: 'default'
            }
        },
        computed: {
            user() { return this.$getLS(this.$v.STORE_KEYS.USER) },
            sellers() { return this.$store.state.sellers },
            customerService() { return this.$store.state.customerService },
            userHistoryEvents() { return this.$store.state.userHistoryEvents }
        },
        async created() {
            this.isAdmin = this.user.role === this.$v.ROLES.ADMIN
        },
        methods: {
            formatCurrency(value) {
                return this.$formatCurrency(value)
            },
            pageSelected(page) {
                this.$emit("pageSelected", page);
            },
            formatDate(date) {
                return this.$moment(date).format("DD MMM YYYY, h:mm a")
            },
            setPeriod(){
                this.showSetPeriod=true
                this.period.start=null
                this.period.end=null
                this.getPeriodFilterText()                
            },
            setPeriodFilter(value) {        
                if(value!=2){
                    this.showSetPeriod = false
                    this.periodFilter = value
                    this.$emit("setPeriodFilter", value);
                    
                }else if(this.period.start && this.period.end){
                    this.periodFilter = value
                    this.$emit("setPeriodFilter", value);
                }
                
            },
            getPeriodFilterText() {
                if(this.showSetPeriod)
                    return "Periodo del: "
                else if(this.periodFilter === 1)
                    return "Mes actual"
                else return "Fecha"
            },
        }
    }
</script>
<style>
</style>
